export const PRODUCTS = 'USER_INFO';
export const CARTS = 'CARTS';
export const SET_COUPONS = 'SET_COUPONS';
export const SET_COUPONS_CODE = 'SET_COUPONS_CODE';
export const SET_PRODUCTS_DISCOUNT = 'SET_PRODUCTS_DISCOUNT';
